<template>
    <toolbar-option>
        <template slot="primary">
            <dropdown
                :value="selected"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import { LOADERS, DefaultLoader } from '@/data/constants/loaders';

const CUSTOM_ATTR_NAME = 'loaderStyle';

export default {
    name: 'dynamic-collection-loader',

    mixins: [baseOption],

    data() {
        return {
            displayName: 'Loading Animation',
            selected: '',
            loaderOptions: LOADERS,
        };
    },

    computed: {
        options() {
            return [
                ...this.loaderOptions.map(item => ({ text: item, value: item })),
            ];
        },
    },

    methods: {
        onInput(selected) {
            this.selected = selected;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, selected);

            this.setChangedData(true);
        },

        onSelectedElement() {
            const selected = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            this.selected = selected || DefaultLoader;
        },
    },
};
</script>
